export interface CarouselTypeOption {
    label: string;
    value: string;
    centered?: boolean;
    fullW?: boolean;
}

export const CarouselTypeOptions: CarouselTypeOption[]  = [
    { label: 'card-slider-simple', value: 'reply-card-slider-simple' },
    { label: 'card-slider-scale', value: 'reply-card-slider-scale', centered: true },
    { label: 'video-stories', value: 'reply-video-stories' }, 
    { label: 'related-keywords-slider', value: 'reply-related-keywords-slider' },
    { label: 'menu-slider', value: 'reply-menu-slider', fullW: true },
    { label: 'hero-slider-horizontal', value: 'reply-hero-slider-horizontal', fullW: true },
    { label: 'image-slider-full', value: 'reply-image-slider-full' },
    { label: 'data-slider', value: 'reply-data-slider' },
    { label: 'quote', value: 'reply-quote', fullW: true },
    { label: 'info-card-slider', value: 'reply-info-card-slider' },
    { label: 'image-data-3-items', value: 'reply-image-data-3-items' },
    { label: 'image-data-4-items', value: 'reply-image-data-4-items' },
    { label: 'image-data-4-3-items', value: 'reply-image-data-4-3-items' },
    { label: 'horizontal-card-slider', value: 'reply-horizontal-card-slider' },
    { label: 'company-slider', value: 'reply-company-slider', fullW: true },
    { label: 'sdg-slider', value: 'reply-sdg-slider' },
    { label: 'statements-slider', value: 'reply-statements-slider', fullW: true },
    { label: 'quicklink-slider', value: 'reply-quicklink-slider' }
]

